import { Img } from "components";
import { Button, MobileInput, Text } from "components";
import { Link } from "react-router-dom";
import { t } from "i18next";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUserData, resetUserData, updateUserData } from "redux/reducers/user";
import { changeLoader } from "redux/reducers/loader";
import { setSnackbar } from "redux/reducers/snackbar";
import { getAuth } from "redux/reducers/loginData";
import { changeTrigger } from "redux/reducers/trigger";
import globalRequest from "utils/global/globalRequest";
import { ONBOARDING_APIS } from "utils/helper/Enum";
import { getDeviceID, isValidMobile, mobileWithCountryCode, strFormat, validateForm } from "utils/helper/custom";
import { addDeleteGetLocalStorage, storageKeys } from "utils/global/localData";
import { useAppFont } from "utils/helper/useAppFont";

const Signup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const userData = useSelector(getUserData);
  const auth = useSelector(getAuth);

  const [isLogin, setIsLogin] = useState(true);
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    mobile: "",
    firstName: "",
    lastName: "",
    otp: ""
  });
  const [errors, setErrors] = useState({});
  const [timer, setTimer] = useState(0);
  const [disableBtn, setDisableBtn] = useState(false);
  const { interClass, headingClass, interFamily, headingFamily } = useAppFont();

  const update_user_values = (field, value) => {
    setErrors({});
    dispatch(updateUserData({ field, value }));
  };
  const checkMobileExistence = async () => {
    let response = await globalRequest(
      ONBOARDING_APIS?.CHECK_USER_BY_MOBILE,
      "post",
      { mobile_no: formData.mobile.trim() }
    );
    return response?.data;
  };

  const checkUser = async () => {
    let validationErrors = {};
    
    if (isLogin) {
      validationErrors = validateForm({ mobile_no: formData.mobile }, "login", t);
      let mobileValidation = isValidMobile(formData.mobile, t);
      validationErrors = { ...validationErrors, ...mobileValidation };
    } else {
      if (!formData.firstName) {
        validationErrors.firstName = t("firstNameIsRequired");
      }
      if (!formData.lastName) {
        validationErrors.lastName = t("lastNameIsRequired");
      }
      if (!formData.mobile) {
        validationErrors.mobile = t("mobileIsRequired");
      }
      let mobileValidation = isValidMobile(formData.mobile, t);
      validationErrors = { ...validationErrors, ...mobileValidation };
    }

    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      dispatch(changeLoader(true));

      if (isLogin) {
        try {
          let input_data = { mobile_no: formData.mobile.trim() };
          let response = await globalRequest(
            ONBOARDING_APIS?.CHECK_USER_BY_MOBILE,
            "post",
            input_data
          );
          response = response?.data;
          dispatch(changeLoader(false));

          if (response?.status !== "SUCCESS") {
            setErrors({ mobile: response?.message });
            return;
          }

          if (response?.data?.is_new_user == 1) {
            setErrors({ mobile: t("userNotFound") });
            return;
          }

          update_user_values("mobile_no", formData.mobile);
          update_user_values("is_varified", true);
          update_user_values("is_new_user", false);

          await sendOtp();
        } catch (e) {
          dispatch(changeLoader(false));
          dispatch(
            setSnackbar({
              snackbarOpen: true,
              snackbarMessage: e?.message,
              snackbarState: "error",
            })
          );
        }
      } else {
        try {
            const checkResp = await checkMobileExistence();

            if (checkResp?.status !== "SUCCESS") {
              setErrors({ mobile: checkResp?.message });
              dispatch(changeLoader(false));
              return;
            }

            if (checkResp?.data?.is_new_user == 0) {
              setErrors({ mobile: t("mobileAlreadyRegistered") });
              setIsLogin(true);
              dispatch(changeLoader(false));
              return;
            }

          let input_data = {
            type: "email_and_mobile",
            mobile_no: formData.mobile,
            email: "",
            first_name: formData.firstName,
            last_name: formData.lastName
          };

          let response = await globalRequest(
            ONBOARDING_APIS?.SEND_OTP,
            "post",
            input_data
          );
          response = response?.data;
          dispatch(changeLoader(false));

          if (response?.status !== "SUCCESS") {
            dispatch(
              setSnackbar({
                snackbarOpen: true,
                snackbarMessage: response?.message,
                snackbarState: "error",
              })
            );
            return;
          }

          update_user_values("mobile_no", formData.mobile);
          update_user_values("first_name", formData.firstName);
          update_user_values("last_name", formData.lastName);
          update_user_values("is_varified", true);
          update_user_values("is_new_user", true);
          update_user_values("email", "");

          setStep(3);
          setTimer(process.env.REACT_APP_OTP_TIMER || 30);
        } catch (e) {
          dispatch(changeLoader(false));
          dispatch(
            setSnackbar({
              snackbarOpen: true,
              snackbarMessage: e?.message,
              snackbarState: "error",
            })
          );
        }
      }
    }
  };

  const sendOtp = async () => {
    if (timer !== 0) {
      return;
    }

    setErrors({});
    dispatch(changeLoader(true));

    try {
      let input_data = {
        mobile_no: formData.mobile,
        type: "mobile",
        first_name: formData.firstName,
        last_name: formData.lastName,
      };

      let response = await globalRequest(
        ONBOARDING_APIS?.SEND_OTP,
        "post",
        input_data
      );
      response = response?.data;
      dispatch(changeLoader(false));

      if (response?.status !== "SUCCESS") {
        setErrors({ otp: response?.message });
        return;
      }

      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: response?.message,
          snackbarState: "success",
        })
      );

      setStep(3);
      setTimer(process.env.REACT_APP_OTP_TIMER || 30);
      setFormData({ ...formData, otp: "" });
    } catch (e) {
      dispatch(changeLoader(false));
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: e?.message,
          snackbarState: "error",
        })
      );
    }
  };

  const verifyOtp = async () => {
    let validationErrors = validateForm({ otp: formData.otp }, "otp", t);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      dispatch(changeLoader(true));

      try {
        let input_data = {
          mobile_no: formData.mobile,
          first_name: formData.firstName,
          last_name: formData.lastName,
          email: "",
          otp: formData.otp,
          device_id: getDeviceID(),
        };

        let response = await globalRequest(
          isLogin ? ONBOARDING_APIS?.LOGIN_WITH_OTP : ONBOARDING_APIS?.SIGNUP,
          "post",
          input_data
        );

        response = response?.data;
        dispatch(changeLoader(false));

        if (response?.status !== "SUCCESS") {
          setErrors({ otp: response?.message });
          return;
        }

        addDeleteGetLocalStorage(
          storageKeys?.USER_TOKEN,
          response?.data?.token,
          "add",
          "single"
        );

        dispatch(changeTrigger("loggedin"));

        const searchParams = new URLSearchParams(location.search);
        const redirect = searchParams.get("redirect");
        const pendingData = localStorage.getItem("pendingOrderData");

        if (pendingData) {
          const parsed = JSON.parse(pendingData);
          localStorage.removeItem("pendingOrderData");
          navigate(parsed.page || redirect || "/");
        } else if (redirect) {
          navigate(decodeURIComponent(redirect));
        } else {
          navigate("/");
        }
      } catch (e) {
        dispatch(changeLoader(false));
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: e?.message,
            snackbarState: "error",
          })
        );
      }
    }
  };

  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);

  useEffect(() => {
    let status = false;

    if (step === 1) {
      if (isLogin) {
        status = !formData.mobile;
      } else {
        status = !formData.firstName || !formData.lastName || !formData.mobile;
      }
    } else if (step === 3) {
      status = !formData.otp || formData.otp.length !== 4;
    }

    setDisableBtn(status);
  }, [formData, step, isLogin]);

  useEffect(() => {
    if (!userData?.is_back_data) {
      dispatch(resetUserData());
    } else {
      update_user_values("is_back_data", false);
    }
  }, []);

  useEffect(() => {
    const redirectParam = new URLSearchParams(location.search).get("redirect");
    const redirectUrl = redirectParam ? decodeURIComponent(redirectParam) : null;
    
    if (auth?.id > 0) {
      const pendingData = localStorage.getItem("pendingOrderData");
      
      if (pendingData) {
        const parsed = JSON.parse(pendingData);
        localStorage.removeItem("pendingOrderData");
        navigate(parsed.page || redirectUrl || "/");
      } else if (redirectUrl) {
        navigate(redirectUrl);
      } else {
        navigate("/");
      }
    }
  }, [auth]);

  return (
    <>
      <div className="min-h-screen flex items-center justify-center bg-[#FBF8F9] py-10 px-4 overflow-x-hidden">
        <div className="w-full max-w-[500px] bg-[#FFFFFF] rounded-2xl shadow-lg p-6 pt-10 sm:p-10">
          
          {step === 3 && (
            <button
              onClick={() => {
                setStep(1);
                setFormData({ ...formData, otp: "" });
              }}
              className={`mb-8 flex items-center gap-2 text-[#6D737E] ${interClass} text-[14px] font-medium`}
            >
              ← Back
            </button>
          )}

            {step === 3 ? (
              !isLogin ? (
                <h1
                  className="mb-6 font-semibold"
                  style={{
                    fontFamily: headingFamily,
                    fontSize: "28px",
                    lineHeight: "36px",
                    color: "#771237",
                  }}
                >
                  {t("welcome")}, {formData.firstName} 👋
                </h1>
              ) : (
                <div className="relative mb-6">
                  <img
                    src="./images/tom.png"
                    alt="RabbitHole Logo"
                    className="absolute z-0 pointer-events-none"
                    style={{
                      width: "50px",
                      height: "50px",
                      left: "clamp(40px, 20%, 81px)",
                      top: "-27px",
                    }}
                  />

                  <h1
                    className="relative z-10 font-semibold break-words"
                    style={{
                      fontFamily: headingFamily,
                      fontSize: "clamp(24px, 6vw, 32px)",
                      lineHeight: "1.25",
                      color: "#771237",
                    }}
                  >
                    {t("joinRabbithole")}
                  </h1>
                </div>
              )
            ) : (
              <div className="relative mb-6">
                <img
                  src="./images/tom.png"
                  alt="RabbitHole Logo"
                  className="absolute z-0 pointer-events-none"
                  style={{
                    width: "50px",
                    height: "50px",
                    left: "clamp(40px, 20%, 81px)",
                    top: "-27px",
                  }}
                />

                <h1
                  className="relative z-10 font-semibold break-words"
                  style={{
                    fontFamily: headingFamily,
                    fontSize: "clamp(24px, 6vw, 32px)",
                    lineHeight: "1.25",
                    color: "#771237",
                  }}
                >
                  {t("joinRabbithole")}
                </h1>
              </div>
          )}

          {step === 1 && (
            <div className="flex bg-[#F8F8F8] rounded-full p-1 mb-6">
              <button
                onClick={() => {
                  setIsLogin(true);
                  setErrors({});
                  setFormData({
                    mobile: "",
                    firstName: "",
                    lastName: "",
                    otp: ""
                  });
                }}
                className={`
                  flex-1 py-2 rounded-full transition ${interClass} text-[16px] sm:text-[18px] font-medium leading-[28px]
                  ${isLogin ? "bg-[#FFFFFF] shadow text-[#1A1A1A]" : "text-gray-500"}
                `}
              >
                {t("login")}
              </button>

              <button
                onClick={() => {
                  setIsLogin(false);
                  setErrors({});
                  setFormData({
                    mobile: "",
                    firstName: "",
                    lastName: "",
                    otp: ""
                  });
                }}
                className={`
                  flex-1 py-2 rounded-full transition ${interClass} text-[16px] sm:text-[18px] font-medium leading-[28px]
                  ${!isLogin ? "bg-[#FFFFFF] shadow text-black" : "text-gray-500"}
                `}
              >
                {t("signup")}
              </button>
            </div>
          )}

          {/* STEP 1 - Mobile and Name */}
          {step === 1 && (
            <>
              {!isLogin && (
                <div className="grid grid-cols-2 gap-4 mb-4">
                  <div>
                    <label
                      className="mb-2 block"
                      style={{
                        color: "#6D737E",
                        fontFamily: interFamily,
                        fontSize: "14px",
                        fontWeight: 500,
                        lineHeight: "16px"
                      }}
                    >
                      {t("firstName")} <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder={t("enterYourFirstName")}
                      className="input figma-input"
                      value={formData.firstName}
                      onChange={(e) =>
                        setFormData({ 
                          ...formData, 
                          firstName: strFormat(e.target.value, "text|max:50")
                        })
                      }
                    />
                    {errors.firstName && (
                      <p className="text-red-500 text-xs mt-1">{errors.firstName}</p>
                    )}
                  </div>

                  <div>
                    <label
                      className="mb-2 block"
                      style={{
                        color: "#6D737E",
                        fontFamily: interFamily,
                        fontSize: "14px",
                        fontWeight: 500,
                        lineHeight: "16px"
                      }}
                    >
                      {t("lastName")} <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder={t("enterYourLastName")}
                      className="input figma-input"
                      value={formData.lastName}
                      onChange={(e) =>
                        setFormData({ 
                          ...formData, 
                          lastName: strFormat(e.target.value, "text|max:50")
                        })
                      }
                    />
                    {errors.lastName && (
                      <p className="text-red-500 text-xs mt-1">{errors.lastName}</p>
                    )}
                  </div>
                </div>
              )}

              <label
                className="mb-2 block"
                style={{
                  color: "#6D737E",
                  fontFamily: interFamily,
                  fontSize: "14px",
                  fontWeight: 500,
                  lineHeight: "16px"
                }}
              >
                {t("mobile")} <span className="text-red-500">*</span>
              </label>

              <div className="flex gap-2 mb-2">
                <div className={`flex items-center gap-2 px-3 py-3 bg-[#FEFEFE] border border-[#E5E7EB] rounded-lg ${interClass} text-[16px] font-normal leading-[24px] text-[#1A1A1A] whitespace-nowrap`}>
                  <Img
                    src="images/img_ellipse4_32x32.png"
                    alt="Saudi Flag"
                    className="rounded-full"
                    style={{
                      width: "22px",
                      height: "22px",
                    }}
                  />
                  <span>+966</span>
                </div>
                <input
                  placeholder="XXX XXX XXX"
                  className="flex-1 input figma-input min-w-0"
                  maxLength={9}
                  value={formData.mobile}
                  onChange={(e) =>
                    setFormData({ 
                      ...formData, 
                      mobile: strFormat(e.target.value, "number|max:9")
                    })
                  }
                />
              </div>
              {errors.mobile && (
                <p className="text-red-500 text-xs mb-4">{errors.mobile}</p>
              )}

              <button
                onClick={checkUser}
                disabled={disableBtn}
                className={`
                  w-full bg-[#7a1236] py-3 rounded-full text-center text-[#FFFFFF] 
                  ${headingFamily} text-[16px] font-medium leading-[24px] mt-4
                  ${disableBtn ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-90'}
                `}
              >
                {isLogin ? t("login") : t("createAccount")}
              </button>
            </>
          )}

          {step === 3 && (
            <div className="w-full">
              <div className="mb-6 rounded-lg bg-[#F0FFF4] border border-[#B7E4C7] px-4 py-3">
                <p className={`text-[14px] ${interClass} text-[#2F855A] break-words`}>
                  {t("otpSentTo")} <span className="font-medium">{mobileWithCountryCode(formData.mobile)}</span>
                </p>
              </div>

              <h2 className={`mb-4 ${interClass} text-[18px] font-medium leading-[28px] text-[#1A1A1A] justify-center flex`}>
                {t("enterOtpCode")}
              </h2>

              <div className="flex gap-2 sm:gap-3 mb-2 justify-around">
                {[...Array(4)].map((_, i) => (
                  <input
                    key={i}
                    maxLength={1}
                    type="text"
                    value={formData.otp[i] || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        const newOtp = formData.otp.split("");
                        newOtp[i] = value;
                        setFormData({ ...formData, otp: newOtp.join("").slice(0, 4) });
                        
                        if (value && i < 5) {
                          const nextInput = e.target.parentElement.children[i + 1];
                          if (nextInput) nextInput.focus();
                        }
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Backspace" && !formData.otp[i] && i > 0) {
                        const prevInput = e.target.parentElement.children[i - 1];
                        if (prevInput) prevInput.focus();
                      }
                    }}
                    className={`w-10 h-10 sm:w-12 sm:h-12 rounded-lg border border-[#E5E7EB] text-center ${interClass} text-[16px] text-[#1A1A1A] focus:outline-none focus:border-[#7a1236]`}
                  />
                ))}
              </div>
              {errors.otp && (
                <p className="text-red-500 text-xs mb-4 text-center">{errors.otp}</p>
              )}

              <p className={`mb-6 ${interClass} text-[16px] font-medium leading-[24px] text-[#727783]`}>
                {t("didntGetACode")}{" "}
                <span
                  onClick={sendOtp}
                  className={`
                    ${interClass} text-[16px] font-medium leading-[24px] cursor-pointer
                    ${timer !== 0 ? 'text-[#A2A6AE] opacity-50' : 'text-[#7a1236]'}
                  `}
                >
                  {t("resendOTP")} {timer > 0 ? `(${timer}s)` : ''}
                </span>
              </p>

              <button
                onClick={verifyOtp}
                disabled={disableBtn}
                className={`
                  w-full bg-[#7a1236] py-3 rounded-full text-[#FFFFFF] text-center 
                  ${headingFamily} text-[16px] font-medium leading-[24px]
                  ${disableBtn ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-90'}
                `}
              >
                {t("verifyOtp")}
              </button>
            </div>
          )}

          {/* {step !== 3 && (
            <p className="text-xs text-gray-500 text-center mt-6">
              {t("whereElegantRosesMeetDeliciousCakes")}
            </p>
          )} */}
            {step !== 3 && (
                <Text
                className="leading-[16.00px] mt-5 text-black-900 text-center text-xs w-full"
                size="txtnunitoRegular12"
                >
                <span className={`text-black-900 ${interClass} font-normal`}>
                    {t(
                    "yourPersonalDataWillBeUsedToAssistYouDuringYourVisitToTheWebsiteManageAccessToYourAccountAndForOtherReasonsDescribedInOur"
                    )}{" "}
                </span>
                <Link
                    to="/privacy-policy"
                    target="_blank"
                    className={`text-blue-900 ${interClass} font-normal underline`}
                >
                    {t("privacyPolicy")}
                </Link>
                .
                </Text>
            )}
        </div>

        <style>
          {`
            .input {
              width: 100%;
              padding: 12px 14px;
              border-radius: 10px;
              border: 1px solid #e5e7eb;
              outline: none;
            }
            .input:focus {
              border-color: #7a1236;
            }
          `}
        </style>
      </div>
    </>
  );
};

export default Signup;
